import request from '@/utils/request'

export function menuApi(){
    return request({
        url: '/coffee/menu/nav',
        method: 'get',
        params:{},
        xrrossSkipGlobal401Logout: true
      })
}
export function menuListApi(){
  return request({
      url: '/coffee/menu',
      method: 'get',
      params:{}
    })
}
export function menuSelectApi(){
  return request({
      url: '/coffee/menu/select',
      method: 'get',
      params:{}
    })
}
export function menuSaveApi(param){
  return request({
    url: '/coffee/menu',
      method: 'post',
      data:param
    })
}
export function menuInfoApi(id){
  return request({
    url: `/coffee/sys/menu/info/${id}`,
      method: 'get',
      params:null
    })
}
/**
 * 
 * @returns 菜单删除
 */
 export function menuDeleteApi(param){
  return request({
      url: '/coffee/menu',
      method: 'DELETE',
      data:param
    })
}
/**
 * 
 * @returns 菜单更新
 */
export function menuUpdateApi(param){
  return request({
      url: '/coffee/menu',
      method: 'put',
      data:param
    })
}

export function roleListApi(param){
  return request({
      url: '/coffee/role/list',
      method: 'post',
      data:param
    })
}
export function roleSaveApi(param){
  return request({
    url: `/coffee/role`,
      method: 'post',
      data:param
    })
}
export function roleUpdataApi(param){
  return request({
    url: `/coffee/role`,
      method: 'put',
      data:param
    })
}
export function roleSelectApi(param){
  return request({
      url: '/coffee/role/list',
      method: 'post',
      data:param
    })
}
export function roleDeleteApi(params){
  return request({
      url: '/coffee/role',
      method: 'delete',
      data:params
    })
}

/** 标准行业职位／权限包目录（标准只读，租户可套用） */
export function orgJobPackCatalogApi(params) {
  return request({
    url: '/coffee/leo/org-job-packs/catalog',
    method: 'get',
    params: params || {}
  })
}

export function orgJobPackPreviewApi(packKey) {
  return request({
    url: '/coffee/leo/org-job-packs/preview',
    method: 'get',
    params: { packKey }
  })
}

export function orgJobPackApplyToRoleApi(param) {
  return request({
    url: '/coffee/leo/org-job-packs/apply-to-role',
    method: 'post',
    data: param
  })
}

export function orgJobCustomJobApi(param) {
  return request({
    url: '/coffee/leo/org-job-packs/custom-job',
    method: 'post',
    data: param
  })
}

export function userMenuListApi(){
  return request({
      url: '/coffee/menu/select',
      method: 'get',
      params:{}
    })
}
/** 角色授權：SSOT 扁平菜單（admin 全量；租戶僅可授權範圍） */
export function roleMenuSelectApi(){
  return request({
      url: '/coffee/menu/select-for-role',
      method: 'get',
      params:{}
    })
}
export function permissionApi(){
  return request({
      url: '/coffee/user/permission',
      method: 'get',
      params:{},
      xrrossSkipGlobal401Logout: true
    })
}





// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/api/sys.js